/* A single modal owns focus, background interaction and scrolling. */
let active: { sheet: HTMLElement; backdrop?: HTMLElement; close: () => void; returnFocus: HTMLElement | null } | null = null;
const previousInert = new Map<HTMLElement, boolean>();

export function openDialog(sheet: HTMLElement, close: () => void, backdrop?: HTMLElement, returnFocus?: HTMLElement): void {
    if (active) active.close();
    active = { sheet, backdrop, close, returnFocus: returnFocus || document.activeElement as HTMLElement | null };
    for (const child of Array.from(document.body.children)) {
        if (!(child instanceof HTMLElement) || child === sheet || child === backdrop) continue;
        previousInert.set(child, child.inert);
        child.inert = true;
    }
    if (backdrop) backdrop.style.display = 'block';
    sheet.style.display = sheet.id === 'onboarding-overlay' ? 'flex' : 'block';
    sheet.tabIndex = -1;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => {
        if (active?.sheet === sheet) sheet.classList.add('is-open');
    });
    sheet.focus();
}

export function closeDialog(sheet: HTMLElement): void {
    if (active?.sheet !== sheet) return;
    const { backdrop, returnFocus } = active;
    active = null;
    sheet.classList.remove('is-open');
    if (backdrop) backdrop.style.display = 'none';
    for (const [element, inert] of previousInert) element.inert = inert;
    previousInert.clear();
    document.body.style.overflow = '';
    // Hide immediately so closed controls cannot receive focus during the exit.
    sheet.style.display = 'none';
    if (returnFocus?.isConnected && returnFocus.getClientRects().length) returnFocus.focus();
}

document.addEventListener('keydown', event => {
    if (!active) return;
    if (event.key === 'Escape') {
        event.preventDefault();
        active.close();
    } else if (event.key === 'Tab') {
        const controls = Array.from(active.sheet.querySelectorAll<HTMLElement>(
            'button:not(:disabled), input:not(:disabled), textarea:not(:disabled), select:not(:disabled), [tabindex="0"]'
        )).filter(el => el.getClientRects().length && !el.inert);
        const first = controls[0];
        const last = controls.at(-1);
        if (!first || !last) {
            event.preventDefault();
            active.sheet.focus();
        } else if (event.shiftKey && (document.activeElement === first || document.activeElement === active.sheet)) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === active.sheet)) {
            event.preventDefault();
            first.focus();
        }
    }
});

document.addEventListener('click', event => {
    if (active?.backdrop && event.target === active.backdrop) active.close();
});
